var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            title: "Cấu hình đại lý",
            visible: _vm.isOpenConfigBrandDialog,
            width: "620px",
            "panel-icon": "el-icon-setting",
            "panel-title": "CẤU HÌNH THAM SỐ GIAO DỊCH",
            "panel-subtitle":
              "Thiết lập quy tắc nhận diện mã thanh toán và cấu hình hạn mức giao dịch tối đa của đại lý.",
            "confirm-loading": _vm.loading.submit,
            "confirm-text": "Cập nhật cấu hình",
            "cancel-text": "Hủy bỏ",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenConfigBrandDialog = $event
            },
            "before-close": _vm.handleClose,
            cancel: _vm.handleClose,
            confirm: _vm.submitForm,
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "modern-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Nhận diện mã thanh toán",
                    prop: "payment_code",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "modern-radio-group",
                      model: {
                        value: _vm.formData.payment_code,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "payment_code", $$v)
                        },
                        expression: "formData.payment_code",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "on" } }, [
                        _vm._v("Có nhận diện"),
                      ]),
                      _c("el-radio", { attrs: { label: "off" } }, [
                        _vm._v("Không nhận diện"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Tiền tố mã thanh toán (Prefix)",
                    prop: "payment_code_prefix",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Nhập tiền tố in hoa (ví dụ: OGV)...",
                      maxlength: "5",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.payment_code_prefix,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "payment_code_prefix", $$v)
                      },
                      expression: "formData.payment_code_prefix",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Độ dài tối thiểu hậu tố",
                            prop: "payment_code_suffix_from",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "full-width-number",
                            attrs: { min: 1, max: 30 },
                            model: {
                              value: _vm.formData.payment_code_suffix_from,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "payment_code_suffix_from",
                                  $$v
                                )
                              },
                              expression: "formData.payment_code_suffix_from",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Độ dài tối đa hậu tố",
                            prop: "payment_code_suffix_to",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "full-width-number",
                            attrs: { min: 1, max: 30 },
                            model: {
                              value: _vm.formData.payment_code_suffix_to,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "payment_code_suffix_to",
                                  $$v
                                )
                              },
                              expression: "formData.payment_code_suffix_to",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Kiểu ký tự hậu tố",
                    prop: "payment_code_suffix_character_type",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: { placeholder: "Chọn kiểu ký tự..." },
                      model: {
                        value: _vm.formData.payment_code_suffix_character_type,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formData,
                            "payment_code_suffix_character_type",
                            $$v
                          )
                        },
                        expression:
                          "formData.payment_code_suffix_character_type",
                      },
                    },
                    _vm._l(_vm.listType, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Số lượng giao dịch tối đa",
                    prop: "transaction_amount",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex gap-2 align-center" },
                    [
                      _c("el-input", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          disabled:
                            _vm.formData.transaction_amount === "Unlimited",
                          placeholder: "Nhập số lượng giao dịch tối đa...",
                        },
                        model: {
                          value: _vm.formData.transaction_amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "transaction_amount", $$v)
                          },
                          expression: "formData.transaction_amount",
                        },
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "modern-checkbox ml-2",
                          on: { change: _vm.handleChangeTransactionAmount },
                          model: {
                            value: _vm.checkTransactionAmount,
                            callback: function ($$v) {
                              _vm.checkTransactionAmount = $$v
                            },
                            expression: "checkTransactionAmount",
                          },
                        },
                        [_vm._v("\n            Không giới hạn\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm.examplePaymentCode
                ? _c("div", {
                    staticClass: "example-badge-box mb-3",
                    domProps: { innerHTML: _vm._s(_vm.examplePaymentCode) },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }